import React from 'react';
import { styled } from '@mui/material/styles';
import { Box, Paper, Grid, Typography, Divider } from '@mui/material';
import { dataConstants } from '../../../constants';
import dynamic from 'next/dynamic';
import LoadingItem from '../../_common/Skeleton/stock';

// const ConsmptionExpenditureGrowth = dynamic(() => import('./ConsmptionExpenditureGrowth'),
//   { loading: () => <LoadingItem /> })
// const RealDisposableIncome = dynamic(() => import('./RealDisposableIncome'),
//   { loading: () => <LoadingItem /> })
// const HistoricalTrend = dynamic(() => import('./HistoricalTrend'),
//   { loading: () => <LoadingItem /> })
// const GDPContribution = dynamic(() => import('./GDPContribution'),
//   { loading: () => <LoadingItem /> })
// const NonDurables = dynamic(() => import('./NonDurables'),
//   { loading: () => <LoadingItem /> })
// const LongTermTrend = dynamic(() => import('./LongTermTrend'),
//   { loading: () => <LoadingItem /> })
// const Total = dynamic(() => import('./Total'),
//   { loading: () => <LoadingItem /> })
// const RetailTradeandFoodPlaces = dynamic(() => import('./RetailTradeandFoodPlaces'),
//   { loading: () => <LoadingItem /> })
// const HistoricalRetailSales = dynamic(() => import('./HistoricalRetailSales'),
//   { loading: () => <LoadingItem /> })
// const SavingsRate = dynamic(() => import('./SavingsRate'),
//   { loading: () => <LoadingItem /> })
// const GasSales = dynamic(() => import('./GasSales'),
//   { loading: () => <LoadingItem /> })
// const HistoricalOnlinevDeptStores = dynamic(() => import('./HistoricalOnlinevDeptStores'),
//   { loading: () => <LoadingItem /> })

import ConsmptionExpenditureGrowth from './ConsmptionExpenditureGrowth';
import RealDisposableIncome from './RealDisposableIncome';
import HistoricalTrend from './HistoricalTrend';
import GDPContribution from './GDPContribution';
import NonDurables from './NonDurables';
import LongTermTrend from './LongTermTrend';
import Total from './Total';
import RetailTradeandFoodPlaces from './RetailTradeandFoodPlaces';
import HistoricalRetailSales from './HistoricalRetailSales';
import SavingsRate from './SavingsRate';
import GasSales from './GasSales';
import HistoricalOnlinevDeptStores from './HistoricalOnlinevDeptStores';
import NoData from '../../_common/NoData';

const Item = styled(Paper)(({ theme }) => ({
  backgroundColor: theme.palette.mode === 'dark' ? 'rgb(10, 25, 41)' : '#fff',
  ...theme.typography.body2,
  height: '100%',
  color: theme.palette.text.secondary,
  boxShadow: theme.palette.mode === 'dark' ? 0 : '0 0.5px 1px rgb(132 135 154 / 20%), 0 2px 3px rgb(132 135 154 / 10%)',
  border: theme.palette.mode === 'dark' ? '1px solid rgb(19, 47, 76)' : 0,
  '& .col-md-4:hover button, .share-wrapper': {
    visibility: 'visible'
  },
  '& .Item-Head': {
    background: '#fbfbfc',
    // borderBottom: '1px solid #eae9ee',
    marginBottom: 0,
    padding: theme.spacing(2),
    paddingBottom: 0,
    borderRadius: '4px 4px 0 0',
    '& a': {
      textDecoration: 'none',
      color: '#333',
      fontWeight: 600,
    },
    '& .option-title': {
      fontWeight: 600,
      color: '#13113c',
      fontSize: '.875rem',
    }
  },
  '& .section': {
    minHeight: '3.4rem',
    borderBottom: '1px solid #eae9ee',
    borderColor: '#eae9ee',
    padding: '9px 10px',
    verticalAlign: 'middle',
    background: '#fbfbfc',
    fontSize: '.875rem',
    '& .option-title': {
      fontSize: '.875rem',
      paddingLeft: theme.spacing(0.5),
      paddingRight: theme.spacing(0.5),
      // fontWeight: '700 !important'
      color: '#000000 !important',
    },
    '& button, .share-wrapper': {
      visibility: 'hidden'
    },
    '.option-desc': {
      color: '#333 !important',
      paddingLeft: theme.spacing(1),
      paddingRight: theme.spacing(1),
    },
  },
  '& .option-desc .MuiTypography-caption': {
    fontSize: '.875rem !important',
  },
  '& .MuiGrid-root': {
    width: '100% !important',
    margin: 0,
  },
  '& .MuiGrid-root > .MuiGrid-item': {
    padding: 0,
    marginLeft: 0,
    marginRight: 0,
  },
}));

const USConsumer = ({ data, themes, getChartData, selectedInfo, onChangeInfo, adStyle, doAppAction }) => {
  const { ECO_SECTION_CODES } = dataConstants || {};
  const [snackPack, setSnackPack] = React.useState([]);
  const [open, setOpen] = React.useState(false);
  const [messageInfo, setMessageInfo] = React.useState(undefined);

  React.useEffect(() => {
    if (snackPack.length && !messageInfo) {
      // Set a new snack when we don't have an active one
      setMessageInfo({ ...snackPack[0] });
      setSnackPack((prev) => prev.slice(1));
      setOpen(true);
    } else if (snackPack.length && messageInfo && open) {
      // Close an active snack when a new one is added
      setOpen(false);
    }
  }, [snackPack, messageInfo, open]);

  const handleClick = (message) => () => {
    setSnackPack((prev) => [...prev, { message, key: new Date().getTime() }]);
  };

  // const handleClose = (event, reason) => {
  //   if (reason === 'clickaway') {
  //     return;
  //   }
  //   setOpen(false);
  // };

  // const handleExited = () => {
  //   setMessageInfo(undefined);
  // };

  //consumer data
  const consData = {};
  const dataArr = data && data.find(d => d.section_code === ECO_SECTION_CODES.CONSUMER_DATA) ? data.filter(d => d.section_code === ECO_SECTION_CODES.CONSUMER_DATA) : undefined;

  dataArr && dataArr.forEach(d => {
    consData[d.settings && d.settings.dataSetName ? d.settings.dataSetName : d.section_code] = (d.tabData || []);
  });
  // const realConsumer = data && data.find(d => d.section_code === ECO_SECTION_CODES.CONS_H_REAL_CHART) ? data.find(d => d.section_code === ECO_SECTION_CODES.CONS_H_REAL_CHART) : undefined;
  // const realConsumerChart = realConsumer && realConsumer.tabData && realConsumer.tabData.length > 0 ? getChartData(realConsumer.tabData[0], getTabData(consData, realConsumer, ECO_SECTION_CODES.CONSUMER_DATA)) : undefined;

  // const realConsumerDis = data && data.find(d => d.section_code === ECO_SECTION_CODES.CONS_H_REAL_DIS_CHART) ? data.find(d => d.section_code === ECO_SECTION_CODES.CONS_H_REAL_DIS_CHART) : undefined;
  // const realConsumerDisChart = realConsumerDis && realConsumerDis.tabData && realConsumerDis.tabData.length > 0 ? getChartData(realConsumerDis.tabData[0], getTabData(consData, realConsumerDis, ECO_SECTION_CODES.CONSUMER_DATA)) : undefined;

  // const realHealthTrend = data && data.find(d => d.section_code === ECO_SECTION_CODES.CONS_H_TREND) ? data.find(d => d.section_code === ECO_SECTION_CODES.CONS_H_TREND) : undefined;
  // const realHealthTrendChart = realHealthTrend && realHealthTrend.tabData && realHealthTrend.tabData.length > 0 ? getChartData(realHealthTrend.tabData[0], getTabData(consData, realHealthTrend, ECO_SECTION_CODES.CONSUMER_DATA)) : undefined;

  // const consumerDura = data && data.find(d => d.section_code === ECO_SECTION_CODES.CONS_C_DUR) ? data.find(d => d.section_code === ECO_SECTION_CODES.CONS_C_DUR) : undefined;
  // const consumerDuraChart = consumerDura && consumerDura.tabData && consumerDura.tabData.length > 0 ? getChartData(consumerDura.tabData[0], getTabData(consData, consumerDura, ECO_SECTION_CODES.CONSUMER_DATA)) : undefined;

  // const consumerNonDura = data && data.find(d => d.section_code === ECO_SECTION_CODES.CONS_C_NON_DUR) ? data.find(d => d.section_code === ECO_SECTION_CODES.CONS_C_NON_DUR) : undefined;
  // const consumerNonDuraChart = consumerNonDura && consumerNonDura.tabData && consumerNonDura.tabData.length > 0 ? getChartData(consumerNonDura.tabData[0], getTabData(consData, consumerNonDura, ECO_SECTION_CODES.CONSUMER_DATA)) : undefined;

  // const consumTrend = data && data.find(d => d.section_code === ECO_SECTION_CODES.CONS_C_TREND) ? data.find(d => d.section_code === ECO_SECTION_CODES.CONS_C_TREND) : undefined;
  // const consumTrendChart = consumTrend && consumTrend.tabData && consumTrend.tabData.length > 0 ? getChartData(consumTrend.tabData[0], getTabData(consData, consumTrend, ECO_SECTION_CODES.CONSUMER_DATA)) : undefined;

  // const consRetail = data && data.find(d => d.section_code === ECO_SECTION_CODES.CONS_RE_TOTAL) ? data.find(d => d.section_code === ECO_SECTION_CODES.CONS_RE_TOTAL) : undefined;
  // const consRetailChart = consRetail && consRetail.tabData && consRetail.tabData.length > 0 ? getChartData(consRetail.tabData[0], getTabData(consData, consRetail, ECO_SECTION_CODES.CONSUMER_DATA)) : undefined;

  // const consRetailBreak = data && data.find(d => d.section_code === ECO_SECTION_CODES.CONS_RE_BREAK) ? data.find(d => d.section_code === ECO_SECTION_CODES.CONS_RE_BREAK) : undefined;
  // const consRetailBreakChart = consRetailBreak && consRetailBreak.tabData && consRetailBreak.tabData.length > 0 ? getChartData(consRetailBreak.tabData[0], getTabData(consData, consRetailBreak, ECO_SECTION_CODES.CONSUMER_DATA)) : undefined;

  // const consRetailTrend = data && data.find(d => d.section_code === ECO_SECTION_CODES.CONS_C_TREND) ? data.find(d => d.section_code === ECO_SECTION_CODES.CONS_RE_TREND) : undefined;
  // const consRetailTrendChart = consRetailTrend && consRetailTrend.tabData && consRetailTrend.tabData.length > 0 ? getChartData(consRetailTrend.tabData[0], getTabData(consData, consRetailTrend, ECO_SECTION_CODES.CONSUMER_DATA)) : undefined;

  // const consRetailOnline = data && data.find(d => d.section_code === ECO_SECTION_CODES.CONS_RE_TREND_ONLINE) ? data.find(d => d.section_code === ECO_SECTION_CODES.CONS_RE_TREND_ONLINE) : undefined;
  // const consRetailOnlineChart = consRetailOnline && consRetailOnline.tabData && consRetailOnline.tabData.length > 0 ? getChartData(consRetailOnline.tabData[0], getTabData(consData, consRetailOnline, ECO_SECTION_CODES.CONSUMER_DATA)) : undefined;

  // const consRetailSaving = data && data.find(d => d.section_code === ECO_SECTION_CODES.CONS_RE_TREND_SAVING) ? data.find(d => d.section_code === ECO_SECTION_CODES.CONS_RE_TREND_SAVING) : undefined;
  // const consRetailSavingChart = consRetailSaving && consRetailSaving.tabData && consRetailSaving.tabData.length > 0 ? getChartData(consRetailSaving.tabData[0], getTabData(consData, consRetailSaving, ECO_SECTION_CODES.CONSUMER_DATA)) : undefined;

  // const consRetailHist = data && data.find(d => d.section_code === ECO_SECTION_CODES.CONS_RE_TREND_HIST) ? data.find(d => d.section_code === ECO_SECTION_CODES.CONS_RE_TREND_HIST) : undefined;
  // const consRetailHistChart = consRetailHist && consRetailHist.tabData && consRetailHist.tabData.length > 0 ? getChartData(consRetailHist.tabData[0], getTabData(consData, consRetailHist, ECO_SECTION_CODES.CONSUMER_DATA)) : undefined;

  return (
    <NoData noData={!data && !data?.length > 0}>
      <Box component="div" className="comer-section">
        <Box component="div" className="row sum-r cons-health">
          <Box component="div" className="col-md-12">
            <Item classNam="sum-r eco-sum-prod" component="div" sx={{ mt: 1, mb: 1.5 }}>
              <Box
                className="Item-Head"
                sx={{
                  display: 'flex',
                  alignItems: 'flex-start',
                  mb: .5,
                  px: 0.5,
                }}
              >
                <Typography component="h2" className="option-title" sx={{ mr: 'auto' }} >
                  {`Consumer Health`}
                </Typography>
              </Box>
              <Box className="option-content prod-body" component="div">
                <Grid container spacing={0} sx={{ flexWrap: { md: 'nowrap', xs: 'wrap' } }}>
                  <Grid size={{ xs: 12, md: 4 }} sx={{ my: 2 }}>
                    <ConsmptionExpenditureGrowth
                      data={data}
                      themes={themes}
                      selectedInfo={selectedInfo}
                      consData={consData}
                      getChartData={getChartData}
                      onChangeInfo={onChangeInfo}
                      handleClick={handleClick}
                    />
                  </Grid>
                  <Grid size={{ xs: 12, md: 4 }} sx={{ my: 2 }}>
                    <RealDisposableIncome
                      data={data}
                      themes={themes}
                      selectedInfo={selectedInfo}
                      consData={consData}
                      getChartData={getChartData}
                      onChangeInfo={onChangeInfo}
                      handleClick={handleClick}
                    />
                  </Grid>
                  <Grid size={{ xs: 12, md: 4 }} sx={{ my: 2 }}>
                    <HistoricalTrend
                      data={data}
                      themes={themes}
                      selectedInfo={selectedInfo}
                      consData={consData}
                      getChartData={getChartData}
                      onChangeInfo={onChangeInfo}
                      handleClick={handleClick}
                    />
                  </Grid>
                </Grid>
              </Box>
            </Item>
          </Box>
        </Box>
        <Box component="div" className="row sum-r cons-consumption">
          <Box component="div" className="col-md-12">
            <Item classNam="sum-r eco-sum-prod" component="div" sx={{ mb: 1.5 }}>
              <Box
                className="Item-Head"
                sx={{
                  display: 'flex',
                  alignItems: 'flex-start',
                  mb: .5,
                  px: 0.5,
                }}
              >
                <Typography component="h3" className="option-title" sx={{ mr: 'auto' }} >
                  {`Real Consumption`}
                </Typography>
              </Box>
              <Box className="option-content prod-body" component="div">
                <Grid container spacing={0} sx={{ flexWrap: { md: 'nowrap', xs: 'wrap' } }}>
                  <Grid size={{ xs: 12, md: 4 }} sx={{ my: 2 }}>
                    <GDPContribution
                      data={data}
                      themes={themes}
                      selectedInfo={selectedInfo}
                      consData={consData}
                      getChartData={getChartData}
                      onChangeInfo={onChangeInfo}
                      handleClick={handleClick}
                    />
                  </Grid>
                  <Grid size={{ xs: 12, md: 4 }} sx={{ my: 2 }}>
                    <NonDurables
                      data={data}
                      themes={themes}
                      selectedInfo={selectedInfo}
                      consData={consData}
                      getChartData={getChartData}
                      onChangeInfo={onChangeInfo}
                      handleClick={handleClick}
                    />
                  </Grid>
                  <Grid size={{ xs: 12, md: 4 }} sx={{ my: 2 }}>
                    <LongTermTrend
                      data={data}
                      themes={themes}
                      selectedInfo={selectedInfo}
                      consData={consData}
                      getChartData={getChartData}
                      onChangeInfo={onChangeInfo}
                      handleClick={handleClick}
                    />
                  </Grid>
                </Grid>
              </Box>
            </Item>
          </Box>
        </Box>
        <Box component="div" className="row sum-r cons-retail">
          <Box component="div" className="col-md-12">
            <Item classNam="sum-r eco-sum-prod" component="div" sx={{ mb: 1.5 }}>
              <Box
                className="Item-Head"
                sx={{
                  display: 'flex',
                  alignItems: 'flex-start',
                  mb: .5,
                  px: 0.5,
                }}
              >
                <Typography component="h3" className="option-title" sx={{ mr: 'auto' }} >
                  {`Retail Sales`}
                </Typography>
              </Box>
              <Box className="option-content prod-body" component="div">
                <Grid container spacing={0} sx={{ flexWrap: { md: 'nowrap', xs: 'wrap' } }}>
                  <Grid size={{ xs: 12, md: 4 }} sx={{ my: 2 }}>
                    <Total
                      data={data}
                      themes={themes}
                      selectedInfo={selectedInfo}
                      consData={consData}
                      getChartData={getChartData}
                      onChangeInfo={onChangeInfo}
                      handleClick={handleClick}
                    />
                  </Grid>
                  <Grid size={{ xs: 12, md: 4 }} sx={{ my: 2 }}>
                    <RetailTradeandFoodPlaces
                      data={data}
                      themes={themes}
                      selectedInfo={selectedInfo}
                      consData={consData}
                      getChartData={getChartData}
                      onChangeInfo={onChangeInfo}
                      handleClick={handleClick}
                    />
                  </Grid>
                  <Grid size={{ xs: 12, md: 4 }} sx={{ my: 2 }}>
                    <HistoricalRetailSales
                      data={data}
                      themes={themes}
                      selectedInfo={selectedInfo}
                      consData={consData}
                      getChartData={getChartData}
                      onChangeInfo={onChangeInfo}
                      handleClick={handleClick}
                    />
                  </Grid>
                </Grid>
              </Box>
            </Item>
          </Box>
        </Box>
        <Box component="div" className="row sum-r cons-retail">
          <Box component="div" className="col-md-12">
            <Item classNam="sum-r eco-sum-prod" component="div" sx={{ mb: 1.5 }}>
              <Box
                className="Item-Head"
                sx={{
                  display: 'flex',
                  alignItems: 'flex-start',
                  mb: .5,
                  px: 0.5,
                }}
              >
                <Typography component="h3" className="option-title" sx={{ mr: 'auto' }} >
                  {`Longer Trends`}
                </Typography>
              </Box>
              <Box className="option-content prod-body" component="div">
                <Grid container spacing={0} sx={{ flexWrap: { md: 'nowrap', xs: 'wrap' } }}>
                  <Grid size={{ xs: 12, md: 4 }} sx={{ my: 2 }}>
                    <SavingsRate
                      data={data}
                      themes={themes}
                      selectedInfo={selectedInfo}
                      consData={consData}
                      getChartData={getChartData}
                      onChangeInfo={onChangeInfo}
                      handleClick={handleClick}
                    />
                  </Grid>
                  <Grid size={{ xs: 12, md: 4 }} sx={{ my: 2 }}>
                    <GasSales
                      data={data}
                      themes={themes}
                      selectedInfo={selectedInfo}
                      consData={consData}
                      getChartData={getChartData}
                      onChangeInfo={onChangeInfo}
                      handleClick={handleClick}
                    />
                  </Grid>
                  <Grid size={{ xs: 12, md: 4 }} sx={{ my: 2 }}>
                    <HistoricalOnlinevDeptStores
                      data={data}
                      themes={themes}
                      selectedInfo={selectedInfo}
                      consData={consData}
                      getChartData={getChartData}
                      onChangeInfo={onChangeInfo}
                      handleClick={handleClick}
                    />
                  </Grid>
                </Grid>
              </Box>
            </Item>
          </Box>
        </Box>
      </Box>
    </NoData>
  );
}

export default (USConsumer);
